<template>
    <section>
        <SideBar />
        <TopBar />
        <div class="content">
            <form class="mb-9" @submit.prevent="validar()">
                <div class="row justify-content-between align-items-end g-3 mb-5">
                    <div class="col-12 col-sm-auto col-xl-9">
                        <h2 class="mb-0" v-if="modo == 'Creando'">Nuevo Aviso</h2>
                        <h2 class="mb-0" v-else >Modificando Aviso</h2>

                        <div class="text-end">
                            <router-link to="/avisos" class="btn btn-outline-primary text-nowrap">Regresar</router-link>
                        </div>
                    </div>
                    <div class="col-12 col-sm-auto col-xl-3">
                        <div class="d-flex">
                            <button type="submit" class="btn btn-primary w-100 text-nowrap">Publicar Aviso</button>
                        </div>
                    </div>
                   
                </div>
                <div class="row g-5">
                    <div class="col-xl-8">
                        <div class="row gx-3 gy-4">
                            <div class="col-sm-12 col-md-12">
                                <div class="form-floating">
                                    <textarea class="form-control" v-model="aviso.aviso" style="height:100px"></textarea>
                                    <label >Aviso</label>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-4">
                                <div class="form-floating">
                                    <input class="form-control" v-model="aviso.fecha_inicial" type="date" />
                                    <label >Fecha Inicio</label>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-4">
                                <div class="form-floating">
                                    <input class="form-control" v-model="aviso.fecha_final" type="date" />
                                    <label >Fecha Final</label>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-4">
                                <div class=" mb-6">
                                    <div class="form-floating">
                                        <select  class="form-control" v-model="aviso.activo">
                                            <option value="1">Activo</option>
                                            <option value="0">Inactivo</option>
                                        </select>
                                        <label for="floatingEventInput">Activo</label>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6">
                                <div class="form-floating">
                                    <select class="form-select" v-model="aviso.empresa_id" >
                                        <option disabled selected="selected">Selecciona...</option>
                                        <option v-for="(dato,x) in empresas" :key="x" :value="dato.id">{{dato.nombre}}</option>
                                    </select>
                                    <label for="floatingSelectTask">Empresa</label>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6">
                                <div class="form-floating">
                                    <select class="form-select" v-model="aviso.sistema_id" >
                                        <option disabled selected="selected">Selecciona...</option>
                                        <option v-for="(dato,x) in sistemas" :key="x" :value="dato.id">{{dato.nombre}}</option>
                                    </select>
                                    <label for="floatingSelectTask">Sistema</label>
                                </div>
                            </div>
                        </div>
                    </div>
                 
                </div>
            </form>
        </div>
    </section>
  </template>
  
  <script>
  // @ is an alias to /src
  import SideBar from '@/components/SideBarNav.vue'
  import TopBar from '@/components/TopBarNav.vue'
  import axios from 'axios'
  
  export default {
    name: 'CrearAvisoView',
    components:{SideBar,TopBar},
    data(){
        return{
            aviso:{},
            empresas:{},
            sistemas:{},
            modo: (this.$route.params.id > 0 ? 'Modificando' : 'Creando'),
        }
    },
    created(){
        this.getReqs()
        if(this.modo == 'Modificando') this.getData()
    },
    methods:{
        getReqs(){
            axios.get(this.$url+'/empresas',{
                headers: {
                    'Content-Type' : 'application/json',
                    'Authorization' : this.$store.state.token
                }
            })
            .then((res)=>{
             
                if(res.data.message){
                    this.$notify({
                        group: 'iasc',
                        title: 'Error',
                        text: res.data.message,
                        type: 'error'
                    });
                }else{
                    this.empresas = res.data
                }
            }).catch((err)=>{
                if(err.response) {
                    if(err.response.status == 500) this.logout()
                }
                this.$notify({
                    group: 'iasc',
                    title: 'Error',
                    text: err.response.data.message,
                    type: 'error'
                });
                 
            })

            axios.get(this.$url+'/sistemas',{
                headers: {
                    'Content-Type' : 'application/json',
                    'Authorization' : this.$store.state.token
                }
            })
            .then((res)=>{
                if(res.data.message){
                    this.$notify({
                        group: 'iasc',
                        title: 'Error',
                        text: res.data.message,
                        type: 'error'
                    });
                }else{
                    this.sistemas = res.data
                }
            }).catch((err)=>{
                if(err.response) {
                    if(err.response.status == 500) this.logout()
                }
                this.$notify({
                    group: 'iasc',
                    title: 'Error',
                    text: err.response.data.message,
                    type: 'error'
                });
            })
        },
        validar(){
            if(this.modo == 'Creando' && !this.aviso.aviso){
                this.$notify({
                    group: 'iasc',
                    title: 'Error',
                    text: 'No se puede agregar un aviso sin contenido',
                    type: 'error'
                });
            }else if(this.modo == 'Modificando' && !this.aviso.aviso ){
                this.$notify({
                    group: 'iasc',
                    title: 'Error',
                    text: 'No se puede modificar un aviso sin contenido',
                    type: 'error'
                });
            }else{
                this.setaviso()
            }
        },
        setaviso(){
            axios.post(this.$url+(this.modo == 'Creando' ? '/aviso' : '/aviso/'+this.$route.params.id),this.aviso,{
                headers: {
                    'Content-Type' : 'application/json',
                    'Authorization' : this.$store.state.token
                }
            })
            .then((res)=>{
                if(res.data.message){
                    this.$notify({
                        group: 'iasc',
                        title: 'Error',
                        text: res.data.message,
                        type: 'error'
                    });
                }else{
                    this.$router.push({name: 'avisos'})
                }
            }).catch((err)=>{
                if(err.response) {
                    if(err.response.status == 500) this.logout()
                }
                this.$notify({
                    group: 'iasc',
                    title: 'Error',
                    text: err.response.data.message,
                    type: 'error'
                });
            })
        },
        getData(){
            axios.get(this.$url+'/aviso/'+this.$route.params.id,{
                headers: {
                    'Content-Type' : 'application/json',
                    'Authorization' : this.$store.state.token
                }
            })
            .then((res)=>{
                if(res.data.message){
                    this.$notify({
                    group: 'iasc',
                    title: 'Error',
                    text: res.data.message,
                    type: 'error'
                });
                }else{
                    this.aviso = res.data
                }
            }).catch((err)=>{
                if(err.response) {
                    if(err.response.status == 500) this.logout()
                }
                this.$notify({
                    group: 'iasc',
                    title: 'Error',
                    text: err.response.data.message,
                    type: 'error'
                });
            })
        }
    }
  }
  </script>
  